"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Builds AST for GraphQL arguments from an array of arguments */
function buildArguments(args) {
    return args.map(function (arg) { return ({
        kind: "Argument",
        name: {
            kind: "Name",
            value: arg,
        },
        value: {
            kind: "Variable",
            name: {
                kind: "Name",
                value: arg,
            },
        },
    }); });
}
exports.buildArguments = buildArguments;
/** Returns all variable names if the arguments array is undefined */
function getArguments(vars, args) {
    if (args)
        return args;
    return Object.keys(vars);
}
exports.getArguments = getArguments;
